export default "__VITE_ASSET__J$nwqFqX__"